<template>
  <v-col cols="12">
    <BaseBlock :title="titreInformation" v-if="messageInformation">
      <div v-html="messageInformation.message"></div>
    </BaseBlock>
  </v-col>
</template>

<script>
import ApiRefMessageRepository from "@/repositories/ApiRefMessageRepository";
import BaseBlock from "@/components/base/BaseBlock";
export default {
  components: {
    BaseBlock,
  },
  data() {
    return {
      messageInformation: null,
      titreInformation: null,
    };
  },
  async beforeRouteUpdate(to, from, next) {
    //    console.log(to);
    this.messageInformation = await ApiRefMessageRepository.getByType(
      "INFORMATION_" + to.params.type
    );
    this.titreInformation = "Information " + to.params.type;
    next();
  },
  async created() {
    //console.log(this.$route.params.type);
    this.messageInformation = await ApiRefMessageRepository.getByType(
      "INFORMATION_" + this.$route.params.type
    );
    this.titreInformation = "Information " + this.$route.params.type;
    //console.log(this.messageInformation.message);
  },
};
</script>
